import { render, staticRenderFns } from "./BackIcon.vue?vue&type=template&id=bc7ac10a&scoped=true&"
import script from "./BackIcon.vue?vue&type=script&lang=js&"
export * from "./BackIcon.vue?vue&type=script&lang=js&"
import style0 from "./BackIcon.vue?vue&type=style&index=0&id=bc7ac10a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7ac10a",
  null
  
)

export default component.exports